import { CatalogFlow } from './catalogDoc';
import { GraphDevice } from './graph';
import { CatalogWizardArgs } from './catalogChain';
import { applySht21Hardware, mergeSht21Catalog } from './catalogSht21';
import { applyModbusSlaveHardware, mergeModbusCatalog } from './catalogModbus';
import { applyStacklightHardware, mergeStacklightCatalog } from './catalogStacklight';
import { applySmlHardware, mergeSmlCatalog } from './catalogSml';
import { applyGpioInputHardware, mergeGpioInputCatalog } from './catalogGpioInput';
import {
  applyStacklightLegacyHardware,
  mergeStacklightLegacyCatalog,
} from './catalogStacklightLegacy';
import { applyGpioActuatorHardware, mergeGpioActuatorCatalog } from './catalogGpioActuator';

export type CatalogWizard = {
  merge: (doc: CatalogFlow, args: CatalogWizardArgs) => CatalogFlow;
  apply: (values: Record<string, unknown>, device: GraphDevice) => Record<string, unknown>;
};

const WIZARDS: Record<string, CatalogWizard> = {
  sht21: { merge: mergeSht21Catalog, apply: applySht21Hardware },
  modbus_slave: { merge: mergeModbusCatalog, apply: applyModbusSlaveHardware },
  stacklight: { merge: mergeStacklightCatalog, apply: applyStacklightHardware },
  sml: { merge: mergeSmlCatalog, apply: applySmlHardware },
  gpio_input: { merge: mergeGpioInputCatalog, apply: applyGpioInputHardware },
  gpio_relay: { merge: mergeGpioActuatorCatalog, apply: applyGpioActuatorHardware },
  gpio_led: { merge: mergeGpioActuatorCatalog, apply: applyGpioActuatorHardware },
  gpio_buzzer: { merge: mergeGpioActuatorCatalog, apply: applyGpioActuatorHardware },
  stacklight_legacy: { merge: mergeStacklightLegacyCatalog, apply: applyStacklightLegacyHardware },
};

export function catalogWizardFor(type: string): CatalogWizard | undefined {
  return WIZARDS[type];
}
